const $ = jQuery;

$(".js-vertical-tab-content").hide();
$(".js-vertical-tab-content:first").show();

/* if in tab mode */
$(".js-vertical-tab").mouseover(function() {
	$(".js-vertical-tab-content").hide();
	var activeTab = $(this).attr("rel");
	$("#" + activeTab).show();

	$(".js-vertical-tab").removeClass("is-active");
	$(this).addClass("is-active");

	$(".js-vertical-tab-accordion-heading").removeClass("is-active");
	$(".js-vertical-tab-accordion-heading[rel^='" + activeTab + "']").addClass("is-active");
});

/* if in accordion mode */
$(".js-vertical-tab-accordion-heading").mouseover(function() {
	$(".js-vertical-tab-content").hide();
	var accordion_activeTab = $(this).attr("rel");
	$("#" + accordion_activeTab).show();

	$(".js-vertical-tab-accordion-heading").removeClass("is-active");
	$(this).addClass("is-active");

	$(".js-vertical-tab").removeClass("is-active");
	$(".js-vertical-tab[rel^='" + accordion_activeTab + "']").addClass("is-active");
});

$('.sliding-panel-content li.menu-item-has-children > a').click(function (e) {
	e.preventDefault();
	if ($(this).hasClass('open')) {
		$(this).removeClass('open');
		$(this).parent().find('.sub-menu').removeClass('open');
	} else {
		$(this).addClass('open');
		$(this).parent().find('.sub-menu').addClass('open');
	}
});



// WEBPACK FOOTER //
// ./src/js/vertical-tabs.js